import React from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import { EsosaProvider } from '../AIAssistant/EsosaContext';
import EsosaAssistant from '../AIAssistant/EsosaAssistant';
interface AdminLayoutProps {
  children: React.ReactNode;
}
const AdminLayout: React.FC<AdminLayoutProps> = ({
  children
}) => {
  return <EsosaProvider data-id="element-128">
      <div className="flex h-screen bg-gray-100" data-id="element-129">
        <AdminSidebar data-id="element-130" />
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-131">
          <AdminHeader data-id="element-132" />
          <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8" data-id="element-133">
            {children}
          </main>
          {/* AI Assistant */}
          <EsosaAssistant data-id="element-134" />
        </div>
      </div>
    </EsosaProvider>;
};
export default AdminLayout;